<template>
  <div :class="name">
    <el-date-picker v-model="threeWord.dt"
                    type="date"
                    size="mini"
                    placeholder="Pick a day"
                    :default-value="threeWord.dt"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd">
    </el-date-picker>
    <el-select v-model="threeWord.serviceId"
               size="mini"
               placeholder="서비스 선택"
               @change="handleChangeService">
      <el-option v-for="(service, serviceId) in services"
                 :key="serviceId"
                 :label="service.name"
                 :value="service.id">
      </el-option>
    </el-select>
    서비스에서
    <el-select v-model="threeWord.domainId"
               :disabled="threeWord.serviceId === ''"
               size="mini"
               placeholder="도매인 선택">
      <template v-if="threeWord.serviceId !== ''">
        <el-option v-for="(domain, domainId) in getGroupByServices('range_group')"
                   :key="domainId"
                   :label="domain.full_name"
                   :value="domainId">
        </el-option>
      </template>
    </el-select>
    의
    <el-select v-model="threeWord.actionId"
               :disabled="threeWord.serviceId === ''"
               size="mini"
               placeholder="권한 선택">
      <template v-if="threeWord.serviceId !== ''">
        <el-option v-for="(action, actionId) in getGroupByServices('action_group')"
                   :key="actionId"
                   :label="action.explain"
                   :value="actionId">
        </el-option>
      </template>
    </el-select>
    권한을 가진 사용자
    <el-button @click="handleFindMembers"
               size="mini"
               type="warning">
      Search
    </el-button>

    <div v-if="membersWithAuthority.length > 0">

    </div>
    <div v-if="threeWord.serviceId !== ''
              && threeWord.domainId !== ''
              && threeWord.actionId !== ''
              && {}.hasOwnProperty.call(services, threeWord.serviceId)">
      <p>
        {{services[threeWord.serviceId].name}}({{services[threeWord.serviceId].explain}})서비스에서
        {{services[threeWord.serviceId].range_group[threeWord.domainId].full_name}}의
        {{services[threeWord.serviceId].action_group[threeWord.actionId].title}}권한을 가진 사용자들 입니다.
      </p>
    </div>

    <el-table :id="`${name}`"
              :class="`${name}`"
              :data="membersWithAuthority"
              border
              v-loading="isLoading"
              :row-class-name="({ row }) => row.id"
              :row-key="row => row.id"
              :expand-row-keys="expandRowKeys"
              @expand-change="handleSelectMember"
              size="mini"
              :fit="true">
      <el-table-column type="expand"
                       :column-key="`${'expand'}`">
        <template slot-scope="props">
          <el-timeline :reverse="reverse">
            <el-timeline-item v-for="(activity, index) in logOfMemberWithAuthority"
                              :key="index"
                              :timestamp="activity.dt">
              {{activity.actor_name}}({{activity.actor_id}})님이
              "{{activity.comment}}"의 이유로
              {{activity.type}}하였습니다.
            </el-timeline-item>
          </el-timeline>
        </template>
      </el-table-column>
      <template v-for="(key) in localIndicator">
        <el-table-column :prop="`${key}`"
                         :key="key"
                         :label="key"
                         :sortable="true"
                         :column-key="key">
          <template slot-scope="scope">
            <template v-if="key === 'name'">
              <span style="background-color: white">{{scope.row.id}}</span><br>
              <strong :class="scope.row.id">{{getName(key, scope.row)}}</strong><br>
            </template>
            <template v-else-if="key === 'img_url'">
              <el-image
                style="width: 100px; height: 100px "
                :style="scope.row.proc_status === 2 ? 'border:2px solid red' : 'border:2px solid white'"
                :src="scope.row.img_url"
                fit="cover">
              </el-image>
            </template>
            <template v-else>
              {{scope.row[key]}}
            </template>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <!--<EmployeeList/>-->
  </div>
</template>

<script>
import format from 'date-fns/format';

import { mapGetters } from 'vuex';
import EmployeeList from '@/container/EmployeeList';
import getName from '@/mixins/getName';

export default {
  filters: {

  },
  mixins: [
    getName,
  ],
  components: {
    EmployeeList,
  },
  computed: {
    ...mapGetters([
      'services',
      'isLoading',
      'membersWithAuthority',
      'logOfMemberWithAuthority',
    ]),
  },
  created() {
    // http://localhost:8081/permission?serviceId=adi&domainId=anipang&actionId=view
    const threeWord = {
      serviceId: '',
      domainId: '',
      actionId: '',
    };
    let isSubmit = true;
    const query = { ...this.$route.query };

    Object.keys(threeWord).forEach((word) => {
      if ({}.hasOwnProperty.call(query, word)) {
        threeWord[word] = query[word];
      } else {
        isSubmit = false;
      }
    });
    threeWord.dt = format(new Date(), 'yyyy-MM-dd');
    this.threeWord = threeWord;
    if (isSubmit) {
      this.handleFindMembers();
    }
  },
  methods: {
    getGroupByServices(group) {
      let returnGroup = {};

      if ({}.hasOwnProperty.call(this.services, this.threeWord.serviceId)) {
        returnGroup = this.services[this.threeWord.serviceId][group];
      }
      return returnGroup;
    },
    handleChangeService() {
      this.threeWord.domainId = '';
      this.threeWord.actionId = '';
    },
    handleFindMembers() {
      let isValidate = true;
      const list = [];

      Object.keys(this.threeWord).forEach((word) => {
        if (this.threeWord[word] === '') {
          list.push(word);
          isValidate = false;
        }
      });
      if (isValidate) {
        this.$store.dispatch('GET_MEMBERS_WITH_AUTHORITY_DATA', this.threeWord);
      } else {
        alert(`${list.join()} 하나이상 선택해 주세요`);
      }
    },

    // ///////////////////////////////////////////////////////
    handleSelectMember(row) {
      this.handleExpandChange(row);
      this.getMemberHistoryByAction(row);
    },

    handleExpandChange(row) {
      const id = row.id;
      const lastId = this.expandRowKeys[0];

      this.expandRowKeys = id === lastId ? [] : [id];
    },

    getMemberHistoryByAction(row) {
      this.$store.dispatch('GET_LOG_OF_MEMBER_WITH_AUTHORITY_DATA', { ...this.threeWord, userId: row.id });
    },
  },

  data() {
    return {
      name: 'Permission',
      email: '',
      threeWord: null,
      expandRowKeys: [],
      localIndicator: [
        'img_url',
        'name',
      ],
      reverse: true,
    };
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/Permission.vue